import { ArrowLeftCircle, ArrowRightCircle } from 'react-feather';

import styles from './Pagination.module.css';
import { Typography } from '../typography';

interface PaginationProps {
  currentPage: number;
  handlePrevPage: TypeAny;
  handleNextPage: TypeAny;
  maxPages: number;
  hasMore: boolean;
}

export function Pagination({
  currentPage,
  handlePrevPage,
  handleNextPage,
  maxPages,
  hasMore
}: PaginationProps) {
  return (
    <div className={styles.pagination}>
      <button
        className={styles.paginationButton}
        disabled={currentPage < 1}
        onClick={handlePrevPage}
        type="button"
      >
        <ArrowLeftCircle size={20} />
      </button>

      <span>
        <Typography sizes={['body-small', 'bold']}>{currentPage + 1}</Typography>
        <Typography sizes={['body-small']}>{` / ${maxPages}`}</Typography>
      </span>

      <button
        className={styles.paginationButton}
        disabled={!hasMore}
        onClick={handleNextPage}
        type="button"
      >
        <ArrowRightCircle size={20} />
      </button>
    </div>
  );
}
